module.exports = __webpack_public_path__ + "static/img/eyes_08.5534772.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_08.png
// module id = UyRN
// module chunks = 0